var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-datepicker',{staticClass:"date-picker",attrs:{"type":_vm.type,"range-separator":_vm.rangeSeparator,"value":_vm.jsDateValue,"format":_vm.datePickerFormat,"disabled":_vm.disabled},on:{"input":function($event){return _vm.handleChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }